import React, { useRef } from 'react';
import Chart from 'react-google-charts';
import { v4 as uuidv4 } from 'uuid';
import './Chart.scss';

export const ChartComponent = ({
  chartType,
  className,
  content,
  width = null,
  height = null,
  chartOptions,
  checkChartClick = false,
  chartRef,
}) => {
  const chartIdRef = useRef(uuidv4());
  
  // This is a workaround for those cases when the mouse cursor has left the tooltip area,
  // but the tooltip has not disappeared
  const onMouseEnter = () => {
    const tooltip = document.querySelector('.google-visualization-tooltip.hidden');
  
    if (tooltip?.dataset?.id === chartIdRef.current) {
      setTimeout(() => {
        tooltip?.classList?.remove('hidden');
      }, 100);
    }
  };

  const onMouseLeave = () => {
    const tooltip = document.querySelector('.google-visualization-tooltip:not(.hidden)');

    if (tooltip) {
      tooltip.classList.add('hidden');
      tooltip.setAttribute('data-id', chartIdRef.current);
    }
  };

  return (
    <div style={{ width, height }} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <Chart
        className={className}
        chartType={chartType}
        data={content}
        width={width}
        height={height}
        chartEvents={
          checkChartClick
            ? [
                {
                  eventName: 'ready',
                  callback: ({ chartWrapper, google }) => {
                    if (chartRef) {
                      chartRef.current = chartWrapper.getChart();
                    }

                    checkChartClick(chartWrapper, google);
                  },
                },
              ]
            : []
        }
        options={chartOptions}
      />
    </div>
  );
};
